"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsPage = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var pageHeader_1 = require("../../../../components/pageHeader");
var console_1 = require("../../../../reducers/slices/console");
var statistic_triggers_1 = require("./statistic_triggers");
var timezone_1 = require("./timezone");
var SettingsPage = function () {
    var dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(function () {
        dispatch((0, console_1.setPageTitle)("Account Settings"));
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(pageHeader_1.PageHeader, { icon: "solar:settings-linear", title: "Account Settings" }), (0, jsx_runtime_1.jsxs)("div", { className: "grid grid-cols-2 gap-4", children: [(0, jsx_runtime_1.jsx)(statistic_triggers_1.StatisticTriggers, {}), (0, jsx_runtime_1.jsx)(timezone_1.Timezone, {})] })] }));
};
exports.SettingsPage = SettingsPage;
